import { SkeletonBox, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const OwnersSectionSkeletonBox = styled(SkeletonBox)`
  margin-bottom: ${Spacing.S32};
`
